<script setup lang="ts">
const { user: userInfo } = useUser();
const { routes, user, assignedSalesUser } = userInfo.value;
</script>

<template>
    <template v-if="assignedSalesUser">
        <BaseText class="mb-7">
            Kontaktieren Sie jederzeit Ihre Ansprechperson, um Ihre
            gewünschten Infos zu erhalten.
        </BaseText>
        <div class="flex flex-col items-center">
            <NuxtImg
                v-if="assignedSalesUser?.thumbnail"
                :src="assignedSalesUser?.thumbnail"
                width="80"
                height="80"
                placeholder
                class="mb-6 rounded-full border border-gray-900"
                alt="Ansprechperson Bild"
            />
            <BaseText variant="base-500">
                {{ assignedSalesUser.firstName }}
                {{ assignedSalesUser.lastName }}
            </BaseText>
            <BaseText>{{ assignedSalesUser.position }}</BaseText>
            <div class="mt-2">
                <JamBaseLink
                    v-if="assignedSalesUser.phone"
                    as="a"
                    variant="green"
                    :href="'tel:' + assignedSalesUser.phone"
                >
                    {{ assignedSalesUser.phone }}
                </JamBaseLink>
            </div>
            <JamBaseLink
                v-if="assignedSalesUser.email"
                as="a"
                variant="green"
                :href="'mailto:' + assignedSalesUser.email"
            >
                {{ assignedSalesUser.email }}
            </JamBaseLink>
        </div>
    </template>
    <template v-else>
        <BaseText>
            Als Online Shop Kunde haben Sie keine persönliche
            Ansprechperson. Kontaktieren Sie uns unter
            <JamBaseLink
                as="a"
                variant="green"
                href="mailto:shop-support@karriere.at"
            >
                shop-support@karriere.at
            </JamBaseLink>
            oder lesen Sie in unserem
            <JamBaseLink
                as="a"
                variant="green"
                :href="routes.faqs"
                target="_blank"
            >
                FAQ Bereich
            </JamBaseLink>
            nach um alle relevanten Informationen zu erhalten.

            <JamBaseLink
                as="a"
                variant="green"
                :href="routes.faqs"
                target="_blank"
            >
                Zu den FAQ
            </JamBaseLink>
        </BaseText>
    </template>
</template>
